import React, {
    Component
} from 'react';

import AppFooter from '../../components/app-footer/AppFooter';
import FormLogin from './components/form-login/FormLogin';
import RecuperarClave from './components/recuperarclave/RecuperarClave';
import ApiClient from '../../utils/ApiClient';
import UiUtils from '../../utils/UiUtils';
import UserDemo from './components/user-demo/UserDemo';
import lstrings from '../../utils/LStrings';
import { authenticate } from '../api';

class Home extends Component {

    constructor() {
        super();

        this.state = {
            mostrarRecuperarClave: false,
            mostrarUserDemo: false,
        };
    }

    onLogin = (userName, password) => {
        UiUtils.showProgress(true);
        authenticate(userName, password)
			.then(function (res) {
                UiUtils.showProgress(false);
                if (res.success == true) {
                    UiUtils.navigateTo('/dashboard');
                } else {
                    throw new Error(res.reason);
                }
            }).catch(function (error) {
                UiUtils.showProgress(false);
                switch (error.response.status) {
                    case 401:
                        return UiUtils.showAlert("Error", "Usuario no Autorizado");
                    case 400:
                        return UiUtils.showAlert("Error", "Verifique usuario y/o contraseña");
                    default:
                        return UiUtils.showAlert("Error", "Ocurrió un error inesperado");
                }
            });
    }

    mostrarRecuperarClave = () => {
        this.setState({
            mostrarRecuperarClave: true
        });
    }

    cerrarRecuperarClave = () => {
        this.setState({
            mostrarRecuperarClave: false
        });
    }
    mostrarUserDemo = () => {
        this.setState({
            mostrarUserDemo: true
        });
    }

    cerrarUserDemo = () => {
        this.setState({
            mostrarUserDemo: false
        });
    }

    render() {
        return (
            <div>
                <div className="wrapper-home">
                    <RecuperarClave
                        mostrarRecuperarClave={this.state.mostrarRecuperarClave}
                        onCerrarRecuperarClave={this.cerrarRecuperarClave}/>
                    <UserDemo
                        mostrarUserDemo={this.state.mostrarUserDemo}
                        onCerrarUserDemo={this.cerrarUserDemo}/>
                    <FormLogin
                        onMostrarRecuperarClave={this.mostrarRecuperarClave}
                        onLogin={this.onLogin}
                        onMostrarUserDemo={this.mostrarUserDemo}/>
                </div>
                <div className="clearfix"/>
                <AppFooter/>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/scenes/home/Home.js